import { getScript } from 'ui-helpers';

/* eslint-disable class-methods-use-this */
class Paypal {
  constructor(args) {
    const $this = this;
    $this.paypalLandingPage = '/paypal';
    $this.paypal = window.paypal;
    if (args) {
      Object.assign(this, args);
    }
    if (!Element.prototype.matches) {
      Element.prototype.matches = Element.prototype.msMatchesSelector;
    }
  }

  async createOrder() {
    const paypalLegacyReturnCancelUrl = 'https://www.paypal.com/checkoutnow/error';
    const { globals } = window;
    const paypalParams = {
      cancelUrl: paypalLegacyReturnCancelUrl,
      returnUrl: paypalLegacyReturnCancelUrl,
    };
    return fetch(globals.paths.setPaypalExpressCheckout, {
      body: JSON.stringify(paypalParams),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
    })
      .then((res) => res.json())
      .then((data) => data.Data.Token);
  }

  onApprove(data) {
    const { orderID, payerID } = data;
    window.location.href = `/Ordering/Checkout/Review?token=${orderID}&PayerID=${payerID}`;
  }

  onClick(data) {
    const page = window.digitalData.page.pageInfo.pageType;
    const pageVar = page === 'checkout' ? 'shipping' : page;
    const { fundingSource } = data;
    const isPayPalCredit = fundingSource === 'credit' || fundingSource === 'venmo';
    this.triggerAnalyticsEvent(pageVar, isPayPalCredit);
  }

  triggerAnalyticsEventBanners = (page, mktBannerId) => {
    window.ddoEventInit({
      category: {
        primaryCategory: 'button submission',
      },
      eventInfo: {
        eventName: 'flex button',
        eventDescription: `paypal banner - ${page} page - ${mktBannerId.substr(1)}`,
      },
    });
  };

  triggerAnalyticsEvent = (page, isFinancing) => {
    if (isFinancing) {
      window.ddoEventInit({
        category: {
          primaryCategory: 'button submission',
        },
        eventInfo: {
          eventName: 'flex button',
          eventDescription: `paypal credit - ${page} page`,
        },
      });
    } else {
      const pageVar = page === 'checkout' ? 'shipping' : page;
      window.ddoEventInit({
        category: {
          primaryCategory: 'button submission',
        },
        eventInfo: {
          eventName: `blinds paypal ${pageVar}`,
        },
      });
    }
  };

  addHorizontalButtons(container, stylesParam) {
    const $this = this;
    const defaultStyles = {
      color: 'gold',
      fundingicons: false,
      height: 41,
      label: 'paypal',
      layout: 'horizontal',
      shape: 'rect',
      tagline: false,
    };
    const style = { ...defaultStyles, ...stylesParam };
    if (typeof this.paypal !== 'undefined') {
      this.paypal
        .Buttons({
          createOrder: this.createOrder,
          onApprove: this.onApprove,
          onClick: (data) => {
            $this.onClick(data);
          },
          style,
        })
        .render(container);
    }
  }

  addVerticalButtons(container) {
    const $this = this;
    if (typeof this.paypal !== 'undefined') {
      this.paypal
        .Buttons({
          createOrder: this.createOrder,
          onApprove: this.onApprove,
          onClick: (data) => {
            $this.onClick(data);
          },
          style: {
            color: 'gold',
            fundingicons: false,
            label: 'paypal',
            layout: 'vertical',
            shape: 'rect',
            tagline: false,
          },
        })
        .render(container);
    }
  }

  watchClickOnMarketingBanners = (mktBannerContainerSelector) => {
    const $this = this;
    const mktBannersObj = {
      iframeMouseOver: false,
    };

    window.addEventListener('blur', () => {
      window.setTimeout(() => {
        if (
          document.activeElement instanceof HTMLIFrameElement &&
          document.activeElement.closest(mktBannerContainerSelector)
        ) {
          const page = window.digitalData.page.pageInfo.pageType;
          $this.triggerAnalyticsEventBanners(page, mktBannerContainerSelector);
        }
      }, 0);
    });

    document.addEventListener('mouseover', (event) => {
      if (event.target.matches('[title="paypal_buttons"]')) {
        mktBannersObj.iframeMouseOver = true;
      }
    });

    document.addEventListener('mouseout', (event) => {
      if (event.target.matches('[title="paypal_buttons"]')) {
        mktBannersObj.iframeMouseOver = false;
      }
    });
  };

  addMarketingBanner(containerSelector, options) {
    const container = document.querySelector(containerSelector);
    if (container) {
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }
      this.watchClickOnMarketingBanners(containerSelector);

      const { pageContextJavascript } = window;
      const defaultOptions = {
        style: {
          layout: 'text',
          logo: {
            type: 'primary',
            position: 'left',
          },
        },
      };
      // eslint-disable-next-line no-param-reassign
      options = options || {};
      getScript(
        `https://www.paypal.com/sdk/js?client-id=${pageContextJavascript.paypalClientId}&components=messages`
      ).then(() => {
        const { paypal } = window;
        paypal.Messages({ ...defaultOptions, ...options }).render(containerSelector);
      });
    }
  }

  updateMarketingBanner(containerSelector, options) {
    const container = document.querySelector(containerSelector);
    if (container) {
      const defaultOptions = {
        style: {
          layout: 'text',
          logo: {
            type: 'primary',
            position: 'left',
          },
        },
      };
      const newOptions = options || {};
      const { paypal } = window;
      paypal.Messages({ ...defaultOptions, ...newOptions }).render(containerSelector);
    }
  }
}

export default Paypal;
